import React from 'react';

function Search() {

  return (
    <div className="search-bar">
      <i class="fa fa-search" aria-hidden="true"></i>
      <input className="search" type="text" placeholder="Search market"></input>
    </div>
  );
}

export default Search;